import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { FontWithOutline } from "../../generic/font-with-outline/FontWithOutline";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
export var ResourceProduct = function (props) {
    var buffAmount = props.buffAmount, amount = props.amount, id = props.id;
    return (React.createElement("div", { className: "flex flex--aligned flex--stacked", key: id },
        React.createElement(ResourceIcon, { resource: props, styleId: IdStyles.IconLarge }),
        React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
            React.createElement(NumberFormat, { amount: amount, format: TypeNumberFormat.None }),
            buffAmount && (React.createElement(NumberFormat, { amount: buffAmount, format: TypeNumberFormat.AddExceptZero })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/inventory/resource/ResourceProduct.tsx
// module id = 2256
// module chunks = 3